import { GET_MAIN_INFO_DATA } from "@/constants/Query";
import { IMainInfoData } from "@/types/apiResponse.types";
import { apiRequest } from "@/utils/apiRequest";
import { useQuery } from "@tanstack/react-query";

const useGetMainInfoDataRequest = () => {
  return useQuery<{
    data: {
      data: IMainInfoData;
    };
  }>({
    queryKey: [GET_MAIN_INFO_DATA],
    queryFn: () => apiRequest(GET_MAIN_INFO_DATA, "get"),
  });
};
export default useGetMainInfoDataRequest;
